import type { AutocompleteOption } from 'shared/search/types';
import { safeParseISO } from 'shared/util/datetime-fns';
import type { Filters } from '@/domain';

export const emptyDestination: AutocompleteOption = {
    id: '',
    text: '',
};

export const hasSearchParams = (filters: Filters): boolean =>
    Boolean(
        (filters.city && filters.city?.length > 0) ||
            (filters.country && filters.country?.length > 0) ||
            (filters.booking_from && filters.booking_from?.length > 0 && filters.booking_to && filters.booking_to?.length > 0) ||
            (filters.no_of_bedrooms_from && filters.no_of_bedrooms_from > 0) ||
            (filters.no_of_beds_from && filters.no_of_beds_from > 0),
    );

export const dateOrNull = (date: string): Date | null => (date ? safeParseISO(date) : null);

export const formatGuestAndBedroomText = (beds: number, bedrooms: number): string =>
    `${beds < 1 ? 'Alle gjester' : beds > 1 ? `${beds} gjester` : '1 gjest'}, ${bedrooms ? `fra ${bedrooms} soverom` : 'Alle soverom'}`;

export const formatDestinationText = (destination?: AutocompleteOption | null): string => {
    if (destination?.city) {
        return `${destination.city}, ${destination.country}`;
    }
    if (destination?.country) {
        return destination.country;
    }
    return '';
};

export const populateDestination = (filters: Filters): AutocompleteOption =>
    filters.city
        ? {
              id: `${filters.city}, ${filters.country}`,
              text: `${filters.city}, ${filters.country}`,
              city: filters.city,
              country: filters.country ?? undefined,
              bounds: {
                  southwest_lat: Number(filters.lat_sw),
                  southwest_lng: Number(filters.lng_sw),
                  northeast_lat: Number(filters.lat_ne),
                  northeast_lng: Number(filters.lng_ne),
              },
          }
        : filters.country
          ? {
                id: `${filters.country}`,
                text: `${filters.country}`,
                city: undefined,
                country: filters.country,
                bounds: {
                    southwest_lat: Number(filters.lat_sw),
                    southwest_lng: Number(filters.lng_sw),
                    northeast_lat: Number(filters.lat_ne),
                    northeast_lng: Number(filters.lng_ne),
                },
            }
          : emptyDestination;
